import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "super-custom-upload-inner" }
const _hoisted_3 = { class: "super-custom-upload-btn" }
const _hoisted_4 = ["id", "accept"]
const _hoisted_5 = ["for"]
const _hoisted_6 = { class: "super-custom-upload-inner" }
const _hoisted_7 = { class: "super-custom-upload-btn" }
const _hoisted_8 = ["id", "accept"]

import { reactive, ref, onMounted, computed } from "vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomUploadInput',
  props: {
        id: { type: String, required: true },
        label: { type: String, default: 'Fichier' },
        type: { type: String, default: 'ALL' },
        preview: { type: String },
        size: { type: String as () => 'normal' | 'small', default: 'normal' },
    },
  emits: ["uploaded"],
  setup(__props, { emit: __emit }) {

    // @ts-expect-error raison: lib externe mal typée
    const emit = __emit
    const props = __props;

    const allExtensionsInfos = {
        'ALL': {
            extensions_allowed: '',
            extensions_labels: 'Tous les fichiers'
        },
        'VIDEO': {
            extensions_allowed: '.mp4,.avi,.mov,.mkv',
            extensions_labels: 'MP4, MOV, AVI, MKV'
        },
        'IMAGE': {
            extensions_allowed: '.jpg,.jpeg,.png,.gif,.webp,.svg',
            extensions_labels: 'JPG, PNG, GIF, Webp, SVG'
        },
    };
    const extensionsAllowed = ref('');
    const extensionsLabels = ref('');
    const formValue = reactive({
        file: '',
        file_name: '',
        file_preview: null as any,
    });
    const previewComponent = computed(() => formValue.file_preview ?? props.preview);

    onMounted(() => {
        extensionsAllowed.value = allExtensionsInfos[props.type as keyof typeof allExtensionsInfos].extensions_allowed;
        extensionsLabels.value = allExtensionsInfos[props.type as keyof typeof allExtensionsInfos].extensions_labels;
    });

    function onFileUploaded(event: any) {
        if (event.target.files.length > 0) {
            var reader = new FileReader();
            reader.onload = function(e) {
                formValue.file = event.target.files[0];
                formValue.file_name = event.target.files[0].name;
                formValue.file_preview = e.target!.result as string;
                emit('uploaded', formValue);
            }
            reader.readAsDataURL(event.target.files[0]);
        }
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.size == 'normal')
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: props.id,
          class: "super-custom-upload rounded-100 active",
          style: _normalizeStyle({ background: `url('${previewComponent.value ?? ''}')`, backgroundSize: 'cover', backgroundPosition: 'center' })
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h6", null, _toDisplayString(props.label), 1),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("input", {
                id: props.id,
                class: "display-none",
                type: "file",
                ref: "fichier_photo",
                onChange: _cache[0] || (_cache[0] = ($event: any) => (onFileUploaded($event))),
                accept: extensionsAllowed.value
              }, null, 40, _hoisted_4),
              _cache[2] || (_cache[2] = _createElementVNode("img", {
                src: "/icons/icon-upload.svg",
                class: "super-custom-upload-icon"
              }, null, -1))
            ]),
            _createElementVNode("span", null, _toDisplayString(extensionsLabels.value), 1),
            _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1))
          ])
        ], 12, _hoisted_1))
      : _createCommentVNode("", true),
    (props.size == 'small')
      ? (_openBlock(), _createElementBlock("label", {
          key: 1,
          for: props.id,
          class: "super-custom-upload small rounded-100 active",
          style: _normalizeStyle({ background: `url('${previewComponent.value ?? ''}')`, backgroundSize: 'cover', backgroundPosition: 'center' })
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("input", {
                id: props.id,
                class: "display-none",
                type: "file",
                ref: "fichier_photo",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (onFileUploaded($event))),
                accept: extensionsAllowed.value
              }, null, 40, _hoisted_8),
              _cache[4] || (_cache[4] = _createElementVNode("img", {
                src: "/icons/icon-upload.svg",
                class: "super-custom-upload-icon"
              }, null, -1))
            ]),
            _createElementVNode("span", null, _toDisplayString(extensionsLabels.value), 1),
            _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1))
          ])
        ], 12, _hoisted_5))
      : _createCommentVNode("", true)
  ], 64))
}
}

})